module.exports = __webpack_public_path__ + "img/assessment.209f456a.svg";